module.exports = __webpack_public_path__ + "static/media/pool.40659fc9.jpg";